import {CountryModel, OrganizationModel, ShipModel } from './';

export class InternationalShipSecurityCertificateModel {
  isscId: number;
  expiryDate: Date;
  rsoIssuerId: number;
  governmentIssuerId: number;
  certificateNumber: string;
  issuedByGovernment: boolean;
  // models
  rsoIssuer: OrganizationModel;
  governmentIssuer: CountryModel;
  // list models
  ship: ShipModel[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/international-ship-security-certificate-model.ts